import * as _ from 'lodash';

export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '6',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Photo',
    sortable: false,
    sort: 'desc',
    active: false,
    colSize: '5',
    col: 'photo',
    columnName: 'photo',
    type: 'image',
    link: false,
  },
  {
    title: 'Part no.',
    sortable: true,
    truncate: true,
    sort: 'desc',
    active: false,
    colSize: '7',
    col: 'partNumber',
    columnName: 'partNumber',
    link: false,
    data: (row: any) => {
      return _.get(row, 'partNumber');
    },
  },
  {
    title: 'Description',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'description_des_en',
    colSize: '12',
    columnName: 'description_des_en',
    truncate: true,
    data: (row: any) => {
      return _.get(row, 'descriptions.DES.EN');
    }
  },
  {
    title: 'Fitments',
    sortable: false,
    sort: 'desc',
    active: false,
    colSize: '5',
    col: 'fitments',
    columnName: 'fitments',
    link: false,
    permissions: ['admin', 'fitments'],
  },
];
